import React, { useContext, useEffect, useState } from 'react'
import { Link } from "react-router-dom"
import { ShoppingBag } from "react-feather"
import { CartContext, UserContext } from "@/App"
import { useNavigate } from "react-router-dom";
import CartList from "@/ui/CartList"
import CartSummary from "@/ui/CartSummary"
import Button from "@/components/Button"
import PageHeader from "@/components/PageHeader"
import api from "@/api"
import toast from "react-hot-toast";
import CheckoutModal from '../components/Checkout'
import { v4 as uuidv4 } from "uuid";
import Input from "@/components/Input";
import { HiChevronDown, HiChevronUp, HiTrash as TrashIcon } from "react-icons/hi2";
import { useGlobalData } from '../context/globalContext';
import {convertPercentToAmount,getPaymentGatewayId} from '../reducers/utils';

export default function CartPage() {
	const navigate = useNavigate();
	const [showCheckoutModal, setShowCheckoutModal] = useState(false)
	const {user} = useContext(UserContext)
	const {cart, cartDispatch} = useContext(CartContext)
	// const  [orderId,setOrderId] = useState();
	const order_id = "ORD-" + uuidv4().slice(0, 8).toUpperCase();
	const subtotal = cart.products.price
	const [coupon_amount, setCouponAmount] = useState(0);
	// const [showAddressForm, setShowAddressForm] = useState(false)
	const  websiteDetails  = useGlobalData();
	const webDetails = websiteDetails.websiteDetails
	
	const setProductQuantity = async (id, quantity) => {
		const item = cart?.products.find(p => p.id == id)
		if (quantity > item?.balance){
			return toast.error("No More Stock Available")
			console.log(item.balance,"out of stock");
		}
		if (quantity < 1) {
			cartDispatch({type: "REMOVE_PRODUCT", payload: id})
			api.removeProductFromCart(id);
			return;
			// if (user){ 
			// 	api.removeProductFromCart(id)
			// }
		}
			cartDispatch({type: "SET_PRODUCT_QUANTITY", payload: {id, quantity}})
			 api.patchCart(id, quantity)
	}

		const handleCheckout = async (discount,chargesTotal) => {
		// const user = api.getUser()
		const key = "orderData" 
		const value ={
			order_id,
			products:cart.products,
			amount:cart.total,
			couponAmount:discount,
			delCharge:chargesTotal
		}
		const resp = await api.createSession(key,value)
		 const updatedData = {
				couponAmount:discount,
				delCharge:chargesTotal
			  }
		const updatedCart = await api.updateCart(updatedData);
		// console.log("session Data",resp);
		setShowCheckoutModal(true)
	}

	const handleCreateOrder = async (address,paymentMethod,couponAmount,delCharge,txn_id,txnorderId,txnAmount,) => {
		const txn_uuid = paymentMethod == "cod" ? "COD-" + uuidv4().slice(0, 8).toUpperCase():txn_id;
		const txn_orderId = paymentMethod == "cod" ? "COD-" + uuidv4().slice(0, 8).toUpperCase():txnorderId;
		const gatewayId = paymentMethod == "cod" ? 0 : getPaymentGatewayId(webDetails?.pg_gateways);
		const user = api.getUser()
		
		const resp = await api.createOrder(user,cart.products, cart.total, address,paymentMethod,order_id,txn_uuid,txn_orderId,couponAmount,delCharge,gatewayId)
		if (resp.status == "ok") {
			console.log("orderid",resp.orderID)
			// setOrderId(resp.orderID)
			 if (paymentMethod== "cod"){
             navigate(`/OrderConfirmation?order_id=${order_id}`,
				{replace:true}
			 );
             }else{
				navigate(`/OrderConfirmation?payment_id=${txn_id}&txnOrder_id=${txnorderId}&order_id=${order_id}&order_total=${txnAmount}`,
                {replace:true}
                );
			 }
			await api.clearCart()
			cartDispatch({type: "RESET"})
		}else{
			alert("Order not placed Checkout the product again")
			 setShowCheckoutModal(false)
		}
	}

	const handleCancel = () => {
		setShowCheckoutModal(false);
		window.location.reload(); // refresh page
    };

	const handlePayment = async (address,paymentMethod,couponAmount,delCharge) => {
		setCouponAmount(couponAmount);
		try{
		const total = cart.total + delCharge - couponAmount
		const key = import.meta.env.VITE_KEY_ID;
		const response = await api.createRazorpayOrder(order_id,user,total,getPaymentGatewayId(webDetails?.pg_gateways))
		console.log("address",address)
		console.log("razorder",response);
		const razOrder = response.razOrder;
		console.log("order",razOrder);
    if(response.success){
        const options = {
        key: key,
        amount: razOrder.amount,	
        currency: "INR",
        // name: "ECOM CLOTHING",
        description: "Payment",
        order_id: razOrder.id,
         handler: async function (response) {
          if (response.razorpay_payment_id) {
            //  console.log("Payment Success Response:", response);
             const apiRes = await api.razorpayPaymentVerify(response,getPaymentGatewayId(webDetails?.pg_gateways))
			 console.log("payment verify",apiRes)
             if(apiRes.success){
                // console.log("Payment verified:", apiRes.data);
				handleCreateOrder(
				address,
				paymentMethod,
				couponAmount,
				delCharge,
				response.razorpay_payment_id,
				response.razorpay_order_id,
				razOrder.amount/100,
			  );	
             }
          } else {
            toast.error("Payment failed");
          }
        },
        prefill: {
          name: user.name || "Guest",
          email: user.email || "test@example.com",
          contact: user.phone,
        },
        theme: { color: "#533C1D" },
      };

      const rzp = new (window).Razorpay(options);
      rzp.open();
    }else{
     toast.error("Payment failed");
    }
  }
   catch (error) {
    console.error("Payment API Error:", error);
    toast.error("Failed to call payment API");
  }
}

	if (cart?.products?.length == 0) {
		return (
			<main className="h-screen flex flex-col items-center text-center my-14 p-4">
				<PageHeader>Your Shopping Cart is Empty</PageHeader>
				<Link to="/products">
					<Button link className="text-xl">
						<ShoppingBag className="mr-2" />
						Continue Shopping
					</Button>
				</Link>
			</main>
		)
	}

	return (
		<main className="my-14">
			<PageHeader>Your Shopping Cart</PageHeader>
			<section className="max-w-6xl mx-auto my-16 relative gap-8 flex flex-col p-4 md:(flex-row items-start)">
				<section className="flex-1 sm:min-w-md divide-y divide-gray-200 border border-gray-300 rounded shadow">
					<CartList 
						items={cart.products} 
						setItemQuantity={(id, qty) => setProductQuantity(id, qty)}
					/>		
				</section>

				<section className="w-full md:w-auto border border-gray-300 rounded shadow py-4 md:(sticky top-20)">
					<CartSummary 
						// onCheckout={() => setShowCheckoutModal(true)}
						onCheckout={handleCheckout}
						subtotal={cart.total.toFixed(2)} 
						charges={[
							webDetails?.del_on_cart ==  true 
							?{name: "Delivery Charges", 
								amount: webDetails.advalorem_specific == "A" 
							    ?Number(cart.total?.toFixed(2)) > Number(webDetails.del_free_val) ? 0 : Number(convertPercentToAmount(cart.total?.toFixed(2),webDetails.eff_tax?.toFixed(2))) ?? 0
								:Number(cart.total?.toFixed(2)) > Number(webDetails.del_free_val) ? 0 : Number(webDetails.eff_tax?.toFixed(2)) ?? 0}
							:{name: "Delivery Charges", amount: cart.products.map(p=>(p?.delCharge ?? 0))}
						]}
						discounts={[
							// {name: "Shipping Discount", amount: 0},
						]}
					/>
				</section>
				</section>

			{showCheckoutModal && 
				<CheckoutModal 
					// onCancel={() => setShowCheckoutModal(false)}
					onCancel={handleCancel} 
					onSuccess={handleCreateOrder}
					onPayment={handlePayment}
				/>
			}
		</main>
	)
}